export default {
  fixed: 'fixed',
  percent: 'percent',
}
